import {Component, h, Fragment} from "preact";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {t} from "../_i18n";
import {Card} from "../_common/layout";
import {formatCurrency, formatDDMMYYYY, stripTags} from "../_common/common";
import {fetchCompany, fetchCompanyOffersEmulation} from "../_rx/jobs/actions";
import '../offers/components/offerCard.scss'
import Badge from "../_common/components/Badge";

type Props = {
    companyOffersEmulation: any,
    fetchCompanyOffersEmulation: typeof fetchCompanyOffersEmulation,
    schedules: any,
    loading: boolean
}


class CompanyCard extends Component<Props, {}> {
    render = ({companyOffersEmulation, schedules, loading}: Props) => companyOffersEmulation && companyOffersEmulation.map((offer: any) => <Card className='m-bottom offerCard'>
        {loading && <div className='loading-card' />}
        <Link key={offer.id} to={'/offers/' + offer.id + '/preview'} className="no-decoration">
                <div className="m-bottom">
                    <div className="flexrow p-x2-all">
                        <div className="col-30 sm-col-15">
                            {offer.company.logo?
                                <div className="card image-squared" style={`background-image:url('${window.env.JOBS_API_basePath}/company/view-logo/${offer.company.logo}');`} />:
                                <div className="card image-squared" />
                            }
                        </div>
                        <div className="col-70 sm-col-85">
                            <div className="flexrow full-width flex-center-x flex-center-y">
                                <div className="col-100 sm-col-100 ">
                                    <h1 className="no-margin font-medium">{offer.title}</h1>
                                </div>
                            </div>
                            <div className="card-text">
                                {offer.display_company_name ?
                                    <Link to={`/company/preview`} className="no-decoration text-info t-upper m-top-half">{offer.company.name} -<span className="d-none sm-d-iblock">&nbsp;</span></Link>
                                    : <span>{offer.companyName}<span className="translucent"> - </span></span>}
                                {offer.city && offer.state  ? <span className="translucent">{`${offer.city} (${offer.state})`} &nbsp;</span> : '' }
                                <span className="sm-d-iblock d-none">| &nbsp; {formatDDMMYYYY(offer.date)}</span>
                                <p className="d-block sm-d-none no-margin-top m-bottom-half m-top-half"> {formatDDMMYYYY(offer.date)}</p>
                                <p className="d-none sm-d-block ellipsis">{stripTags(offer.text)}</p>
                                <p className="no-margin-top m-bottom-half">
                                    {offer.length && <span className="m-bottom-half"> {offer.length} -</span>}
                                    <span className="translucent"> {schedules[offer.schedule]}</span>
                                    {
                                        offer.salary_min && offer.salary_max ?
                                            <span className="m-bottom-half"> - {formatCurrency(offer.salary_min, 0)} - {formatCurrency(offer.salary_max, 0)} </span> :
                                            offer.salary_min ?
                                                ' - ' + formatCurrency(offer.salary_min, 0) :
                                                offer.salary_max ?
                                                    ' - ' + formatCurrency(offer.salary_max, 0) :
                                                    ''
                                    }
                                    {offer.salary_type && <span className="m-bottom-half m-r sm-m-r"> {offer.salary_type}</span>}
                                    {(offer.modality == 'fct') && <span className='m-r m-top-half sm-m-r no-margin-bottom font-medium'>{t('Formación en centro de trabajo')}</span>}
                                    {(offer.isRemoteProcess) && <Badge type='double-green' className='t-upper m-r sm-m-r no-margin-left font-12'><span>{t('proceso online')}</span></Badge>}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
    </Card>)
};

const ConnectedView: any = connect(
    ({}: any)=>({}), {fetchCompanyOffersEmulation, fetchCompany})(CompanyCard as any);


export default ({...props}) =>
    <ConnectedView {...props}/>
;
